export interface BusinessConfig {
  regions: string[];
  views: string[];
}

interface RuntimeConfig {
  apiBaseUrl: string;
  businessRegions: Record<string, BusinessConfig>;
}

let config: RuntimeConfig | null = null;

// Per-stage config from /config.json, so no environment values are baked in.
export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  if (config) {
    return config;
  }
  const response = await fetch('/config.json', { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(`Failed to load /config.json: ${response.status}`);
  }
  config = (await response.json()) as RuntimeConfig;
  return config;
}

function requireConfig(): RuntimeConfig {
  if (!config) {
    throw new Error('Runtime config not loaded; call loadRuntimeConfig() first');
  }
  return config;
}

export function getApiBaseUrl(): string {
  return requireConfig().apiBaseUrl;
}

export function getBusinessRegions(): Record<string, BusinessConfig> {
  return requireConfig().businessRegions ?? {};
}
